import { Edit, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditAcademicSemester = () => {
  return (
    <Edit
      title="Редакция на академичен семестър"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm isEdit />
      </SimpleForm>
    </Edit>
  );
};
export default EditAcademicSemester;
